// UpdateTemplateConfirmationModal.jsx
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Paper,
  Alert,
} from "components/mui";

/**
 * Confirmation shown before overwriting the currently-loaded template via
 * "Update Template". Overwriting replaces the saved template's content; a
 * version-history snapshot is written server-side so it can be restored, but we
 * still confirm because it is a destructive-feeling action on shared content.
 */
function UpdateTemplateConfirmationModal({ open, onClose, onConfirm, templateName, updating }) {
  return (
    <Dialog open={open} onClose={updating ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Update Template</DialogTitle>
      <DialogContent
        sx={{
          textAlign: "left",
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Typography variant="body1">
          This will overwrite the saved template with the current email content.
        </Typography>

        <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
          <Typography>
            <strong>Template:</strong> {templateName || "—"}
          </Typography>
        </Paper>

        <Alert severity="info">
          The previous version is kept in the template&apos;s history, so you can restore it later
          from the Template Manager.
        </Alert>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, pt: 1 }}>
        <Button color="primary" onClick={onClose} disabled={updating}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="warning"
          disabled={updating}
          sx={{ minWidth: 150, fontWeight: 600 }}
        >
          {updating ? "Updating…" : "Overwrite Template"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default UpdateTemplateConfirmationModal;
